import compact from "lodash/compact";
import {
  FiltersV2ContextType,
  FiltersV2State,
  FiltersV2StoreType
} from "PFApp/components/filters_v2/stores/filters_v2_store/filters_v2_store.types";
import { useStoreSelect } from "PFCore/helpers/store";
import { createContext, useContext } from "react";
import { useStore } from "zustand/index";
import { useShallow } from "zustand/react/shallow";

export const getPersistConfig = (suffix?: string) => ({
  name: compact(["filters_v2_context_store", suffix]).join("-"),
  partialize: (state) => ({ isAutoRefreshOn: state.isAutoRefreshOn })
});

export const getInitialFiltersV2Data = (): Omit<FiltersV2State, "id" | "eventsBus"> => ({
  mainFilters: {},
  childrenFilters: {},
  buffer: {
    mainFilters: {},
    childrenFilters: {},
    areChildrenOn: false
  },
  filtersExcludedByScope: [],
  areChildrenOn: false,
  isSidePanelOpen: false,
  areLoading: false,
  isAutoRefreshOn: false,
  persistent: true
});

export const FiltersV2StoreContext = createContext<FiltersV2ContextType>({} as FiltersV2ContextType);

export const useFiltersV2Store = <U>(selector: (state: FiltersV2StoreType) => U) => {
  const store = useContext(FiltersV2StoreContext);

  return useStore(store, useShallow(selector));
};

export const useFiltersV2Actions = () => {
  const store = useContext(FiltersV2StoreContext);

  return useStore(store, (state) => state.actions);
};

export const useFiltersV2Select = <PropertiesType extends keyof FiltersV2State>(
  ...properties: PropertiesType[]
) => useStoreSelect(FiltersV2StoreContext, properties);

export const useFiltersV2EventsBus = () => useFiltersV2Store((state) => state.eventsBus);
